import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import {
    BoothService,
    BoothPopupService,
    BoothComponent,
    BoothDetailComponent,
    BoothDialogComponent,
    BoothPopupComponent,
    BoothDeletePopupComponent,
    BoothDeleteDialogComponent,
    boothRoute,
    boothPopupRoute,
} from './';

const ENTITY_STATES = [
    ...boothRoute,
    ...boothPopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        BoothComponent,
        BoothDetailComponent,
        BoothDialogComponent,
        BoothDeleteDialogComponent,
        BoothPopupComponent,
        BoothDeletePopupComponent,
    ],
    entryComponents: [
        BoothComponent,
        BoothDialogComponent,
        BoothPopupComponent,
        BoothDeleteDialogComponent,
        BoothDeletePopupComponent,
    ],
    providers: [
        BoothService,
        BoothPopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerBoothModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/booth/booth.module.ts